export default "__VITE_ASSET__aa3042ec__"